import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { RoomTypeService } from "./room-type.service";
import { IRoomType } from "./iroomtype";

@Injectable({
    providedIn: 'root'
})
export class RoomTypeResolver implements Resolve<BaseRespone<{ pagination: PaginationResult, roomTypeDetails: IRoomType[] }>> {
    /**
     * Constructor
     */
    constructor(private _roomtypeService: RoomTypeService) {
    }

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, roomTypeDetails: IRoomType[] }>> {
        var data = {
            pageNumber: 0,
            pageSize: 100,
            wardId: Number(route.paramMap.get('wardId'))
        };
        return this._roomtypeService.getAllRoomTypes(data);
    }
}